import * as constants from './constants';

function sortResults(sort, results) {
  switch (sort) {
    case 'price':
      results.sort((a, b) => a.pricing.baseFee - b.pricing.baseFee);
      break;
    case 'rating':
      results.sort((a, b) => b.averageRating - a.averageRating);
      break;
    default:
      return;
  }
  return;
}

export default function Search(state = {
  hoveredListing: undefined,
  mapCenter: null,
  mapMobile: false,
  filters: constants.initialFilters,
  results: [],
  searchComplete: false,
  sort: '',
  i: undefined
}, action) {
  switch (action.type) {
    case constants.HOVERED_LISTING:
      return Object.assign({}, state, {
        hoveredListing: action.data
      });
    case constants.RESET_FILTERS:
      const newFilters = {
        ...constants.initialFilters,
        geometry: state.filters.geometry
      }
      return Object.assign({}, state, {
        filters: newFilters
      });
    case constants.POPULATE_RESULTS:
      sortResults(state.sort, action.data.listings);
      return Object.assign({}, state, {
        results: action.data.listings,
        mapCenter: action.data.mapCenter ? action.data.mapCenter : state.mapCenter,
        i: action.data.i ? action.data.i : undefined
      })
    case constants.SEARCH_COMPLETE:
      return Object.assign({}, state, {
        searchComplete: true
      })
    case constants.SEARCH_STARTED:
      return Object.assign({}, state, {
        searchComplete: false
      })
    case constants.SHOW_MAP:
      return Object.assign({}, state, {
        mapMobile: !state.mapMobile
      });
    case constants.UPDATE_FILTERS:
      let combinedFilters = Object.assign({}, state.filters, action.data);
      return Object.assign({}, state, {
        filters: combinedFilters
      });
    case constants.SEARCH_SET_SORT:
      sortResults(action.data, state.results);
      return Object.assign({}, state, {
        sort: action.data,
        results: state.results.slice(0)
      })
    default:
      return state;
  }
}
